import {
  NOTIFICATION_PANEL_FILTERS,
  NOTIFICATION_TYPES,
  type NotificationPanelFilter,
} from '../constants';
import type { Item } from '../types';
import type { DriverMessageItem } from '../types';
import { isPickupChipNotification } from './pickupNotifications/pickupChipTypes';
import {
  aggregatePickupNotificationsForChip,
} from './pickupNotifications/aggregatePickupNotificationsForChip';
import { getNotificationChipCounts } from './notificationChipCounts';
import { sortByTimestampDesc } from '../../../../common/utils/dateTimeUtils';

export type SplitNotificationData = {
  messages: DriverMessageItem[];
  /** Raw pickup-family items (before per-type chip aggregation). */
  pickupNotifications: Item[];
};

export const splitNotificationData = (data: Item[] = []): SplitNotificationData => {
  const messages: DriverMessageItem[] = [];
  const pickupNotifications: Item[] = [];

  data.forEach((item) => {
    if (item.type === NOTIFICATION_TYPES.DRIVER_MESSAGE) {
      messages.push(item);
    } else if (isPickupChipNotification(item)) {
      pickupNotifications.push(item);
    }
  });

  return { messages, pickupNotifications };
};

export const getNotificationFilterCounts = (data: Item[] = []) => {
  const { messages, pickupNotifications } = splitNotificationData(data);
  return getNotificationChipCounts(
    messages.length,
    pickupNotifications.length
  );
};

export const filterNotificationsByChip = (
  data: Item[] = [],
  activeFilter: NotificationPanelFilter
): Item[] => {
  const { messages, pickupNotifications } = splitNotificationData(data);
  const pickupCards = aggregatePickupNotificationsForChip(pickupNotifications);

  if (activeFilter === NOTIFICATION_PANEL_FILTERS.MESSAGES) {
    return messages;
  }

  if (activeFilter === NOTIFICATION_PANEL_FILTERS.PICKUPS) {
    return pickupCards;
  }

  return sortByTimestampDesc([...messages, ...pickupCards], (item) => item.timestamp);
};
